import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'IssueDetailsCompanyController',
            IssueDetailsCompanyController
        );

    /** @ngInject */
    function IssueDetailsCompanyController(
        $stateParams,
        CompaniesFactory,
        BusinessRelationshipsFactory,
        CostsService,
        LocalStorageService,
        FileSaver,
        ngDialog
    ) {
        var vm = this;
        var companyEmployee;
        var companyId;

        init();

        function init() {
            vm.isAuthorShowed = true;
            vm.showAllLocations = false;
            vm.openCustomFieldsDialog = openCustomFieldsDialog;

            getCompanyEmployee();
        }

        function getCompanyEmployee() {
            companyEmployee = LocalStorageService.getCompanyEmployee();
            companyId = companyEmployee.organization.party_uuid;
        }

        function buildRealEstatesList(locations) {
            var realEstates = [];
            locations.forEach(function (location) {
                if (
                    location.real_estate_name &&
                    realEstates.indexOf(location.real_estate_name) === -1
                ) {
                    realEstates.push(location.real_estate_name);
                }
            });
            if ('Intl' in window && Intl.Collator) {
                var collator = new Intl.Collator(undefined, {
                    numeric: true,
                    sensitivity: 'base',
                });
                realEstates.sort(collator.compare);
            } else {
                realEstates.sort();
            }
            return realEstates;
        }

        CompaniesFactory.readOneIssue(companyId, $stateParams.issue_id).then(
            function (response) {
                vm.dataFromBackend = response.data;
                vm.realEstates = buildRealEstatesList(
                    vm.dataFromBackend.locations
                );
                BusinessRelationshipsFactory.fetchOneClient(
                    vm.dataFromBackend.customer.party_uuid
                ).then(function (response) {
                    vm.configuration = {
                        display_real_estate_info: response.data.display_real_estate_info
                    };
                });

                vm.isAssignedAndForWho = function () {
                    if (vm.dataFromBackend.assigned_to_data.email) {
                        if (
                            vm.dataFromBackend.assigned_to_data.email ===
                                companyEmployee.email ||
                            companyEmployee.manager
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                };

                CompaniesFactory.readCompanies(companyId).then(function (
                    companySettingsResponse
                ) {
                    vm.flexMenuStructure = [
                        [
                            {
                                name: 'Przypisz zgłoszenie',
                                func: changeContractorEvent,
                                if: vm.dataFromBackend.status != 'fixed',
                            },
                            {
                                name: 'Termin realizacji',
                                func: changeTermDate,
                                if:
                                    vm.dataFromBackend.status != 'fixed' &&
                                    vm.isAssignedAndForWho(),
                            },
                            {
                                name: 'Zmień kategorię',
                                func: changeCategory,
                                if: vm.dataFromBackend.issue_category,
                            },
                            {
                                name: 'Zmień lokalizację',
                                func: openIssueLocationsDialog,
                                if: true,
                            },
                            {
                                name: 'Zmień klienta',
                                func: changeClient,
                                if: vm.dataFromBackend.can_change_client,
                            },
                            {
                                name: 'Dodaj pliki',
                                func: addFilesEvent,
                                if: vm.isAssignedAndForWho(),
                            },
                            {
                                name: 'Koszty zgłoszenia',
                                func: addPayInfo,
                                if:
                                    vm.dataFromBackend.status != 'rejected' &&
                                    canUserManageCosts(),
                            },
                            {
                                name: 'Przychód',
                                func: addRevenue,
                                if:
                                    companySettingsResponse.data
                                        .income_calculation &&
                                    companyEmployee.manager,
                            },
                            {
                                name: 'Numer zgłoszenia',
                                func: changeId,
                                if: companySettingsResponse.data
                                    .client_number_assignable,
                            },
                            {
                                name: 'Dodatkowe pola',
                                func: openCustomFieldsDialog,
                                if: vm.dataFromBackend.custom_fields,
                            },
                            {
                                name: 'Zmień opis',
                                func: openDescriptionDialog,
                                if: !vm.dataFromBackend.som_id,
                            },
                            {
                                name: 'Zmień dodatkowe dane osobowe',
                                func: openAdditionalPersonalDataDialog,
                                if: true,
                            },
                            {
                                name: 'Pobierz zgłoszenie',
                                func: downloadIssuePrintout,
                                if: true,
                            },
                            {
                                name: 'Pobierz druk zlecenia',
                                func: downloadJobPrintout,
                                if: true,
                            },
                        ],
                    ];
                });

                CompaniesFactory.readJournal(companyId, $stateParams.issue_id, {
                    page_size: 100,
                }).then(function (response) {
                    vm.journalsFromBackend = response.data.results;
                });
            }
        );

        function canUserManageCosts(): boolean {
            return CostsService.canUserManageCosts(
                vm.dataFromBackend,
                companyEmployee
            );
        }

        function changeContractorEvent() {
            ngDialog.open({
                template: 'changeContractorDialog',
                controller: 'ChangeContractorEmployeeController',
                controllerAs: 'ChangeContractorEmployeeCtrl',
                className: 'dialog-theme',
                data: {
                    issue: vm.dataFromBackend,
                    company: companyId,
                },
            });
        }

        function changeId() {
            ngDialog.open({
                template: 'changeIdDialog',
                controller: 'ChangeIdController',
                controllerAs: 'ChangeIdCtrl',
                className: 'dialog-theme',
                data: {
                    issue: vm.dataFromBackend,
                    company: companyId,
                },
            });
        }

        function changeCategory() {
            ngDialog.open({
                template: 'changeCategoryDialog',
                controller: 'ChangeCategoryDialogController',
                controllerAs: 'ChangeCategoryDialogCtrl',
                className: 'dialog-theme',
                data: {
                    issue: vm.dataFromBackend,
                    company: companyId,
                },
            });
        }

        function changeClient() {
            ngDialog.open({
                template: 'changeClientDialog',
                controller: 'ChangeClientDialogController',
                controllerAs: 'ChangeClientDialogCtrl',
                className: 'dialog-theme',
                data: {
                    issue: vm.dataFromBackend,
                    company: companyId,
                },
            });
        }

        function openAdditionalPersonalDataDialog() {
            ngDialog.open({
                template: 'changeAdditionalPersonalDataDialog',
                controller: 'EditAdditionalPersonalDataDialogController',
                controllerAs: 'EditAdditionalPersonalDataDialogCtrl',
                className: 'dialog-theme',
                data: {
                    issue: vm.dataFromBackend,
                    company: companyId,
                },
            });
        }

        function openDescriptionDialog() {
            ngDialog.open({
                template: 'editDescriptionDialog',
                controller: 'EditDescriptionDialogController',
                controllerAs: 'EditDescriptionDialogCtrl',
                className: 'dialog-theme',
                data: {
                    issue: vm.dataFromBackend,
                    company: companyId,
                },
            });
        }

        function addRevenue() {
            ngDialog.open({
                template: 'revenueDialog',
                controller: 'ChangeRevenueController',
                controllerAs: 'ChangeRevenueCtrl',
                className: 'dialog-theme',
                data: {
                    issue: vm.dataFromBackend,
                    company: companyId,
                },
            });
        }

        function changeTermDate() {
            ngDialog.open({
                template: 'termDialog',
                controller: 'IssueFormTermController',
                controllerAs: 'IssueFormTermCtrl',
                className: 'dialog-theme',
            });
        }

        function addFilesEvent() {
            ngDialog.open({
                template: 'addFilesDialog',
                controller: 'AddFilesDialogController',
                controllerAs: 'AddFilesDialogCtrl',
                className: 'dialog-theme',
            });
        }

        function addPayInfo() {
            ngDialog.open({
                template: 'changeCostsDialog',
                controller: 'ChangeCostsController',
                controllerAs: 'ChangeCostsCtrl',
                className: 'dialog-theme',
                data: {
                    issue: vm.dataFromBackend,
                    company: companyId,
                },
            });
        }

        vm.openChangeStatusWindow = function () {
            ngDialog.open({
                template: 'changeStatusDialog',
                controller: 'ChangeIssueStatusController',
                controllerAs: 'ChangeIssueStatusCtrl',
                className: 'dialog-theme',
                data: {
                    issue: vm.dataFromBackend,
                    company: companyId,
                },
            });
        };

        function openCustomFieldsDialog() {
            ngDialog.open({
                template: 'customFieldsDialog',
                controller: 'ChangeCustomFieldsController',
                controllerAs: 'ChangeCustomFieldsCtrl',
                className: 'dialog-theme',
                data: {
                    issue: vm.dataFromBackend,
                    company: companyId,
                },
            });
        }

        function openIssueLocationsDialog() {
            ngDialog.open({
                template: 'issueLocationsDialog',
                controller: 'IssueLocationsController',
                controllerAs: 'IssueLocationsCtrl',
                className: 'dialog-theme',
                data: {
                    issue: vm.dataFromBackend,
                    company: companyId,
                },
            });
        }

        vm.showAuthor = function () {
            vm.isAuthorShowed = false;

            CompaniesFactory.readAuthorData(
                companyId,
                $stateParams.issue_id
            ).then(function (response) {
                vm.authorDataFromBackend = response.data;
            });
        };

        function getFileNameFromHttpResponse(httpResponse) {
            var contentDispositionHeader = httpResponse.headers(
                'Content-Disposition'
            );
            var result = contentDispositionHeader
                .split(';')[1]
                .trim()
                .split('=')[1];
            return result.replace(/"/g, '');
        }

        function downloadIssuePrintout() {
            CompaniesFactory.downloadIssuePrintout(
                companyId,
                $stateParams.issue_id
            ).then(function (response) {
                downloadFile(
                    response.data,
                    getFileNameFromHttpResponse(response)
                );
            });
        }

        function downloadJobPrintout() {
            CompaniesFactory.downloadJobPrintout(
                companyId,
                $stateParams.issue_id
            ).then(function (response) {
                downloadFile(
                    response.data,
                    getFileNameFromHttpResponse(response)
                );
            });
        }

        function downloadFile(data, name) {
            var blob = new Blob([data], { type: 'application/pdf' });
            FileSaver.saveAs(blob, name);
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/issue_details.controller.ts